const constants = {
  DIMENSIONS: {
    MOBILE: {
      CLOSED: {
        WIDTH: 60,
        WIDTH_STRING: "60px",
        HEIGHT: 60,
        HEIGHT_STRING: "60px",
      },
      OPEN: {
        WIDTH_STRING: "100%",
        HEIGHT_STRING: "100%",
      },
    },
    DESKTOP: {
      CLOSED: {
        WIDTH: 360,
        WIDTH_STRING: "250px",
        HEIGHT: 275,
        HEIGHT_STRING: "275px",
      },
      OPEN: {
        WIDTH: 400,
        WIDTH_STRING: "400px",
        HEIGHT: 700,
        HEIGHT_STRING: "700px",
      },
    },
    // Standalone page on desktop: an app card centered on a branded backdrop
    // rather than a panel pinned to a corner of somebody else's site. HALF is
    // what lets the template slider dock against it with a plain calc(), with
    // no shared layout container between the two components.
    STANDALONE: {
      WIDTH_STRING: "420px",
      HALF_STRING: "210px",
      HEIGHT_STRING: "min(760px, 92vh)",
    },
  },
  FEATURE_FLAGS: {
    SLIDER: true,
    TOOLTIP: true,
    ANALYTICS: true,
  },
};

export default constants;
